module.exports = __webpack_public_path__ + "img/es.24eff4ba.svg";